module.exports = __webpack_public_path__ + "static/media/照片采集中.80e0f30e.png";